const API_KEY = "397350bdf288cf002a86cfe67240e405";
const BASE_PATH = "https://api.themoviedb.org/3";

interface IGenre {
  id: number;
  name: string;
}

export interface ITvShow {
  poster_path: string;
  id: number;
  backdrop_path: string;
  vote_average: number;
  first_air_date: string;
  overview: string;
  name: string;
  genres: IGenre[];
}

export interface IGetTvShowsResults {
  page: number;
  results: ITvShow[];
  total_results: number;
  total_pages: number;
}

export interface IMovie {
  id: number;
  backdrop_path: string;
  poster_path: string;
  title: string;
  overview: string;
  release_date: string;
  vote_average: number;
  runtime: number;
  tagline: string;
  genres: IGenre[];
}

export interface IGetMoviesResult {
  dates: {
    maximum: string;
    minimum: string;
  };
  page: number;
  results: IMovie[];
  total_pages: number;
  total_results: number;
}

export const searchMoviesByKeyword = (
  keyword: string
): Promise<IGetMoviesResult> => {
  console.log(
    `${BASE_PATH}/search/movie?api_key=${API_KEY}&query=${keyword}&page=1`
  );
  return fetch(
    `${BASE_PATH}/search/movie?api_key=${API_KEY}&query=${keyword}&page=1`
  ).then((response) => response.json());
};

export const searchTvShowsByKeyword = (
  keyword: string
): Promise<IGetTvShowsResults> => {
  console.log(
    `${BASE_PATH}/search/tv?api_key=${API_KEY}&query=${keyword}&page=1`
  );
  return fetch(
    `${BASE_PATH}/search/tv?api_key=${API_KEY}&query=${keyword}&page=1`
  ).then((response) => response.json());
};
